import { useNavigate } from 'react-router-dom';
import { useQuery, getEvents } from 'wasp/client/operations';
import { TodayEventsSection } from '../information-desk/InformationDeskPage';
import { REGULAR_EVENTS_LIST_FILTERS } from '../events/eventFilters';

interface Props {
  locationId: string;
  orgSlug: string;
}

/** Today's events block — placed above the information desk on hub pages. */
export function HubTodayEvents({ locationId, orgSlug }: Props) {
  const navigate = useNavigate();

  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString();
  const todayEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1).toISOString();

  const { data: rawEvents = [] } = useQuery(
    getEvents,
    {
      locationId,
      filters: { ...REGULAR_EVENTS_LIST_FILTERS, startDate: todayStart, endDate: todayEnd },
    },
    { enabled: !!locationId }
  );

  return (
    <TodayEventsSection events={rawEvents as any[]} orgSlug={orgSlug} navigate={navigate} />
  );
}
